// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#artwork-share-recipient-keyword[data-v-01a0fdf5]{display:none;width:auto;height:20px;border:none}#artwork-share-recipient-keyword[data-v-01a0fdf5]:focus{background-color:#f8f9fa}.sent-buttons .left[data-v-01a0fdf5]{position:absolute;left:15px}@media (max-width:575px){.sent-buttons[data-v-01a0fdf5]{width:100%}.sent-buttons .left[data-v-01a0fdf5]{position:relative;left:0;display:block;width:100%}.sent-buttons .btn-xs-block[data-v-01a0fdf5]{width:100%}}", ""]);
// Exports
module.exports = exports;
